module.exports = __webpack_public_path__ + "media/books/Books-Intro-Grandparents-68f5ad9c.jpg";